import { styled } from "theme/default/styled";

export const SPopUpContainer = styled.div`
  position: relative;
`;
